import { MutableRefObject } from 'react'
import { StoreApi } from 'zustand'
import { PageTypeEnum } from '@moonpig/web-shared-products'
import type { SearchStoreState } from '../types'

export const shouldReinitialiseState = ({
  store,
  newState,
}: {
  store: MutableRefObject<StoreApi<SearchStoreState> | undefined>
  newState?: Partial<SearchStoreState>
}) => {
  if (!store.current || !newState) {
    return false
  }

  const currentState = store.current.getState() as SearchStoreState
  const currentSearchContext = currentState.searchContext
  const newSearchContext = newState.searchContext

  const hasSearchTermChanged =
    newSearchContext?.searchTerm !== currentSearchContext.searchTerm
  const hasSelectedSuggestionChanged =
    newSearchContext?.selectedSuggestion !==
    currentSearchContext.selectedSuggestion
  const hasDepartmentChanged =
    newSearchContext?.departments[0] !== currentSearchContext.departments[0]
  const isSearchPage = currentState.pageContext.type === PageTypeEnum.SEARCH
  const isCollectionsPage =
    currentState.pageContext.type === PageTypeEnum.COLLECTION
  const isGalleryPage = currentState.pageContext.type === PageTypeEnum.GALLERY

  if (isGalleryPage) {
    return hasDepartmentChanged
  }

  if (isSearchPage || isCollectionsPage) {
    return (
      hasSearchTermChanged ||
      hasSelectedSuggestionChanged ||
      hasDepartmentChanged
    )
  }

  return false
}
